import { render, staticRenderFns } from "./splash.vue?vue&type=template&id=66dcf231&scoped=true"
import script from "./splash.ts?vue&type=script&lang=ts&external"
export * from "./splash.ts?vue&type=script&lang=ts&external"
import style0 from "./splash.less?vue&type=style&index=0&id=66dcf231&prod&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66dcf231",
  null
  
)

export default component.exports